module.exports = __webpack_public_path__ + "img/zt_pic41.530d9813.jpg";